import { useEffect, useState } from "react";
import "./Css.css";
import { useWallet } from "use-wallet";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Web3 from "web3";
import abi from "../pages/abi/stkingcontract.json";
import erc from "../pages/abi/erc20.json";
import RangeSlider from "react-bootstrap-range-slider";
import Countdown from "react-countdown";

import config from "../config";
import moment from "moment";

const MainPage = () => {
  const wallet = useWallet();

  const [staking_contract, setstakingContract] = useState("");
  const [approved, setapproved] = useState(false);
  const [userInfo, setuserInfo] = useState("");
  const [busdInputAmount, setBUSDInputAmount] = useState(0);
  const [lastWithdrawTime, setLastWithdrawTime] = useState(0);
  const [donateAmount, setDonateAmount] = useState();

  // const account = "0xc205902c0e90ac2c258b645ff3c93a90e653e858";
  const { ethereum, account } = wallet;

  const [selectedDays, setSelectedDays] = useState(7);
  const [totalProfitPercent, setTotalProfitPercent] = useState(
    config.BASE_PROFIT_PERCENT
  );

  const toHandsomeNumber = (number) => {
    if (number) {
      return (Number(number) / 1e18).toFixed(2);
    }
    return 0;
  };

  useEffect(() => {
    let baseProfit = config.BASE_PROFIT_PERCENT;
    if (selectedDays > 7) {
      for (let i = 0; i < selectedDays - 7; i++) {
        baseProfit += 5;
      }
    }
    setTotalProfitPercent(baseProfit);
  }, [selectedDays]);
  const loadContract = async () => {
    const web3 = new Web3(ethereum);
    const stakingContract = new web3.eth.Contract(abi, config.CONTRACT_ADDRESS);

    setstakingContract(stakingContract);

    console.log(stakingContract, "stakingcontract");

    const userInfo = await stakingContract.methods.userInfo(account).call();
    const contractinfo = await stakingContract.methods.contractInfo().call();
    const playerInfo = await stakingContract.methods.players(account).call();

    setLastWithdrawTime(playerInfo.last_payout);
    setuserInfo(userInfo);
    console.log(contractinfo, "logs");
  };

  const insertZero = (value, length) => {
    const intialValue = "000000000000000000";
    // const length = value.length;
    const finalstring = intialValue.slice(length);
    console.log(finalstring, value.concat(finalstring), "final");
    return value.concat(finalstring);
  };

  const handleDonate = async () => {
    const web3 = new Web3(ethereum);
    const busdContract = new web3.eth.Contract(erc, config.BUSD_ADDRESS);

    try {
      await busdContract.methods
        .transfer(
          config.DONATE_ADDRESS,
          Web3.utils.toWei(donateAmount.toString())
        )
        .send({
          from: account,
        });
    } catch (erro) {
      console.error("handleDonate", erro);
    }
  };

  const handleDeposit = async () => {
    if (busdInputAmount && selectedDays) {
      const refferalAddress = localStorage.getItem("ref");
      console.log({ refferalAddress: refferalAddress });
      if (!Web3.utils.isAddress(refferalAddress)) {
        refferalAddress = "0x04fb8068d32ccC094b766B7aFBe76588A01d325F";
      }

      console.log({ refferalAddress1: refferalAddress });
      const tx = await staking_contract.methods
        .deposit(
          selectedDays,
          refferalAddress,
          Web3.utils.toWei(busdInputAmount.toString()),
          refferalAddress
        )
        .send({
          from: account,
        });
      if (tx.status) {
        window.location.reload();
      } else {
        alert("transaction failed");
      }
    } else {
      alert("Please enter amount and days");
    }
  };

  const checkApproval = async () => {
    const web3 = new Web3(ethereum);
    const busdToken = new web3.eth.Contract(erc, config.BUSD_ADDRESS);

    console.log(busdToken);

    const allowance = await busdToken.methods
      .allowance(account, config.CONTRACT_ADDRESS)
      .call();
    console.log(allowance, "all");
    if (Number(allowance) > 0) {
      setapproved(true);
    } else {
      setapproved(false);
    }

    console.log("allowance", allowance);
  };

  const handleApprove = async () => {
    const web3 = new Web3(ethereum);
    const busdToken = new web3.eth.Contract(erc, config.BUSD_ADDRESS);

    console.log(busdToken);

    const tx = await busdToken.methods
      .approve(
        config.CONTRACT_ADDRESS,
        "100000000000000000000000000000000000000000000000000000000000000000000000"
      )
      .send({
        from: account,
      });

    if (tx.status) {
      window.location.reload();
    } else {
      setapproved(false);
    }
  };

  useEffect(() => {
    if (wallet.status === "connected") {
      loadContract();

      checkApproval();
    }

    return () => {};
  }, [wallet.status, account, wallet]);

  const handleWithdrawl = async () => {
    const web3 = new Web3(ethereum);
    const stakingContract = new web3.eth.Contract(abi, config.CONTRACT_ADDRESS);
    const tx = await stakingContract.methods.withdraw().send({
      from: account,
    });
  };

  const renderDonateButton = () => {
    if (!account) {
      return (
        <button
          className="btn measure_btn text-uppercase"
          onClick={() => {
            wallet.connect();
          }}
        >
          Connect Wallet
        </button>
      );
    }

    return (
      <button
        className="btn measure_btn text-uppercase background-donate boton-invest"
        onClick={() => {
          handleDonate();
        }}
      >
        Donate Now
      </button>
    );
  };
  const renderButton = () => {
    if (!account) {
      return (
        <button
          className="btn  text-uppercase enable-btn boton-invest"
          style={{ backgroundColor: "#380059" }}
          onClick={() => {
            wallet.connect();
          }}
        >
          Connect
        </button>
      );
    }
    if (approved) {
      return (
        <button
          className="btn measure_btn text-uppercase enable-btn boton-invest"
          style={{ backgroundColor: "#380059" }}
          onClick={() => {
            handleDeposit();
          }}
        >
          Deposit
        </button>
      );
    } else {
      return (
        <button
          className="btn measure_btn text-uppercase backgo enable-btn"
          style={{ backgroundColor: "#380059" }}
          onClick={() => {
            handleApprove();
          }}
        >
          Enable
        </button>
      );
    }
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    return (
      <span>
        {days} Days:{hours} Hours :{minutes} Minutes:{seconds} Seconds
      </span>
    );
  };

  const renderWithdrawButton = () => {
    if (
      userInfo?.total_withdrawn &&
      Number(Web3.utils.fromWei(userInfo?.total_withdrawn)) >= 10000 &&
      Number(lastWithdrawTime) - Date.now() / 1000 <
        config.OVERFLOW_WITHDRAWTIME
    ) {
      return (
        <div>
          <button
            disabled
            className="btn measure_btn text-uppercase"
            onClick={() => {
              handleWithdrawl();
            }}
          >
            Withdraw in{" "}
            {
              <Countdown
                renderer={renderer}
                date={
                  (Number(lastWithdrawTime) + config.OVERFLOW_WITHDRAWTIME) *
                  1000
                }
              />
            }
          </button>
        </div>
      );
    }

    return (
      <button
        className="btn  text-uppercase withdraw-scu"
        onClick={() => {
          handleWithdrawl();
        }}
      >
        Withdraw
      </button>
    );
  };

  return (
    <div>
      <div className="Toastify" />
      <div className="wrapper_outer">
        <Header />
        <section className="banner_section_outer">
          <div className="hero-caption">
            <div className="container-fluid">
              <div className="row d-md-flex align-items-md-center">
                <div className="col-sm-12 col-md-7 col-lg-7">
                  <div className="banner-captions">
                    <h2
                      className="banner-head-a"
                      style={{
                        fontWeight: "900",
                        textShadow: "2px 1px 0 black",
                      }}
                    >
                      Stake and Earn up to 241% of your deposit in BUSD with
                      <span>ROCKY MINER </span>
                    </h2>
                    <h4 className="banner-head-b pt-1 pb-md-2 ">
                      <span style={{ fontWeight: 600, color: "white" }}>
                        Get 8% to 18% ROI And
                      </span>
                      <span
                        style={{
                          fontWeight: 600,
                          marginBottom: "10px",
                          color: "white",
                          display: "inline-block",
                          textShadow: "1px 1px 0 black",
                        }}
                      >
                        <span
                          style={{
                            color: "#",
                            fontWeight: "800",
                            textShadow: "2px 1px 0 black",
                          }}
                        >
                          5 LEVELS
                        </span>{" "}
                        of Referral Commissions{" "}
                      </span>
                    </h4>
                    <p className="pt-md-1 pt-0" />
                    <div className="banner-buttons scu-buttons">
                      <a
                        className="btn btn-a1 min-a text-center mr-md-2 background-donate"
                        href="#deposit"
                      >
                        Deposit
                      </a>
                      <a
                        className="btn btn-a2 min-a text-center withdraw-scu-welcome"
                        style={{
                          border: "2px solid #ff4f3c !important",
                          height: "62px",
                        }}
                        href="#withdraw"
                      >
                        Withdraw
                      </a>
                    </div>
                    <p className="pt-md-1 pt-0" />
                    <p className="pt-md-1 pt-0" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container" id="deposit">
          <h2 className="top_heading" style={{ textShadow: "2px 1px 0 black" }}>
            Measure your Harvest
          </h2>
          <div className="measure_section_outer background-donate bg-sexo">
            <div className="row">
              <div className="col-md-8">
                <div className="measure_section_inner">
                  <div className="vertically-stacked-slider">
                    <p
                      style={{
                        fontWeight: "700",
                        textShadow: "1px .5px 0 black",
                      }}
                    >
                      Deposit Period ({selectedDays} Days){" "}
                    </p>
                    <div className="range-slider">
                      <RangeSlider
                        min={7}
                        max={30}
                        className="input-slider"
                        type="range"
                        variant="warning"
                        value={selectedDays}
                        onChange={(e) => setSelectedDays(e.target.value)}
                        tooltip="on"
                        tooltipPlacement="top"
                        size="lg"
                      />
                      <span
                        className="range-slider__value f_left"
                        style={{
                          float: "left",
                          fontWeight: 600,
                          textShadow: "1px .5px 0 black",
                        }}
                      >
                        7
                      </span>
                      <span
                        className="range-slider__value f_right"
                        style={{
                          fontWeight: 600,
                          textShadow: "1px .5px 0 black",
                        }}
                      >
                        30
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="deposit_amout">
                  <p
                    style={{ fontWeight: 700, textShadow: "1px .5px 0 black" }}
                  >
                    Deposit
                  </p>
                  <input
                    type="number"
                    className="input-deposit"
                    min={0}
                    value={busdInputAmount}
                    onChange={(e) => {
                      setBUSDInputAmount(e.target.value);
                    }}
                  />
                  {/* <span> Min: 5 BUSD</span> */}
                </div>
              </div>
            </div>
            <hr className="hr-a" />
            <div className="row">
              <div className="col-sm-4 col-md-4">
                <div className="measure_contnt">
                  <p style={{ textShadow: "0px .5px 0 black" }}>
                    Daily ROI
                    <span>
                      {(totalProfitPercent / selectedDays).toFixed(2)}%
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-sm-4 col-md-4">
                <div className="measure_contnt">
                  <p style={{ textShadow: "0px .5px 0 black" }}>
                    Total Profit<span>{totalProfitPercent}%</span>
                  </p>
                </div>
              </div>
              <div className="col-sm-4 col-md-4">
                <div className="measure_contnt">
                  <p style={{ textShadow: "0px .5px 0 black" }}>
                    In {selectedDays} Days You Will Earn
                    <span>
                      {((busdInputAmount * totalProfitPercent) / 100).toFixed(
                        2
                      )}{" "}
                      BUSD
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="measure_btn text-center">
              {renderButton()}
              {/* <button className="btn measure_btn text-uppercase">Enable</button> */}
            </div>
          </div>
        </div>
        <div className="container" id="withdraw">
          <div className="dashbord_outer">
            <h2
              className="top_heading"
              style={{ textShadow: "2px 1px 0 black" }}
            >
              Dashboard{" "}
            </h2>
            <div className="row">
              <div className="col-md-3">
                <div className="dashbord_contnt">
                  <p>
                    Total Investment
                    <span>
                      {toHandsomeNumber(userInfo?.total_invested)} BUSD{" "}
                      <br></br>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="dashbord_contnt">
                  <p>
                    Total Withdrawals
                    <span>
                      {toHandsomeNumber(userInfo?.total_withdrawn)} BUSD{" "}
                      <br></br>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="dashbord_contnt">
                  <p>
                    Total Referral Rewards
                    <span>
                      {toHandsomeNumber(userInfo?.total_match_bonus)} BUSD{" "}
                      <br></br>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="dashbord_contnt">
                  <p>
                    Available to Withdraw
                    <span>
                      {(toHandsomeNumber(userInfo?.for_withdraw) * 50) / 100}{" "}
                      BUSD <br></br>
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="measure_btn text-center">
              {renderWithdrawButton()}
            </div>

            <p
              style={{
                position: "relative",
                top: "10px",
                color: "#FFFFFF",
                fontWeight: "600",
                fontSize: 20,
              }}
            >
              {Number(lastWithdrawTime) != 0
                ? `Last Withdraw Time ${moment(
                    Number(lastWithdrawTime) * 1000
                  ).format("DD MMM YYYY hh:mm a")}`
                : null}
            </p>

            <div className="refer_link text-center">
              <p
                style={{
                  position: "relative",
                  top: "10px",
                  textAlign: "center",
                  backgroundColor: "#380059",
                  border: "2px solid #FFFFFF",
                  width: "fit-content",
                  wordBreak: "break-word",
                  margin: "0 auto 17.5px",
                  padding: "10px 12.5px",
                  borderRadius: "15px",
                  fontWeight: "600",
                }}
              >
                <span style={{ fontWeight: 700 }}>Your Referral Link: </span>
                <span>
                  {account ? `${window.location.origin}?ref=${account}` : ""}
                </span>
                <a
                  className="ref-link-copy pointer"
                  onClick={() => {
                    var aux = document.createElement("div");
                    aux.setAttribute("contentEditable", true);
                    aux.innerHTML = `${window.location.origin}?ref=${account}`;
                    aux.setAttribute(
                      "onfocus",
                      "document.execCommand('selectAll',false,null)"
                    );
                    document.body.appendChild(aux);
                    aux.focus();
                    document.execCommand("copy");
                    document.body.removeChild(aux);
                    if (account) {
                      alert("Ref Link Copied");
                    } else {
                      alert("Please Connect Wallet");
                    }
                  }}
                >
                  <img
                    style={{ filter: "invert(1)" }}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAAEcp+bfAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEaADAAQAAAABAAAAFAAAAABGcxxxAAAB1ElEQVQ4Ec1USy8EQRCu6undDbs4IO7iGQlnRyJkd5DYxNEvEP+Bi1/gRxAJidduWFcnkXCSILg5EJfdtY+ZKVVjx/Y+rIuDOkxXf/X1191V1QPAVswsjssI+dP5JRlzqfl11T57tC8TMRRKONbxBNlUggRR8hHDfMpOEkKRiDYFiPZakxosJHK9o1j8BAUURSymF8ZAoyVAZObgRruKhryyuy4AC4MWh5dMyChbfu8iQIMJA3Np2yagFSR1azK0wu3I3KGPaVQYRsAdz/X2giMFZFFxyl6y9V4Vtm7r7DoXP/f+Hgg0jP6NfVI6sUUEq/UMDXoE6W4tUnp+Hq4PSmYE07n7hwKC2qgn8NwnoNRCbsMpuODsR00iIl756fRBghcmJk2CLP71yn9ACIW0X05zb9NXwX1N0PS/sxm0nhkExDeks+WuvJu/5BwM1AR/mChLJc3uFpr+oI9pEWgW/EGnAdbg8kswLJu2X4EoxNCTATe6iG3MG1So1vy3w0JVElE3N+9+NH5cU8Eq4cuTRi6XnWvuuJ5fC1e/uNn8/4joSrlqktvsyK2w6nOosDipJa7XqPycWi10HKdP4lySYtMTFDJ2P4IVayUChBTW4Uec2s1+AhFlr0spcNueAAAAAElFTkSuQmCC"
                    alt="copy link"
                  />
                </a>
              </p>
            </div>
            <p className="pt-md-1 pt-0" />
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="offset-md-3 col-md-6">
              <div
                className="table-responsive"
                style={{ borderRadius: "5px !important" }}
              >
                <p className="pt-md-1 pt-0" />
                <table
                  className="table  text-center"
                  style={{
                    border: "2px solid #FFFFFF",
                    backgroundColor: "#331875",
                    padding: "30px 10px",
                    borderRadius: "45px",
                  }}
                >
                  <thead className="m3-table-head">
                    <tr>
                      <th className="ref-list1-head">Referal Level </th>
                      <th className="ref-list ref-list-head"> Rewards</th>
                      <th className="ref-list2-head"> N° of Referrals </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* <tr style={{ padding: "20px !important" }}>
                      <td className="ref-list1">Level 0 </td>
                      <td className="ref-list">10% </td>
                      <td className="ref-list2">0</td>
                    </tr> */}
                    <tr style={{ padding: "20px !important" }}>
                      <td className="ref-list1">Level 1 </td>
                      <td className="ref-list">8% </td>
                      <td className="ref-list2">1</td>
                    </tr>
                    <tr>
                      <td className="ref-list1">Level 2 </td>
                      <td className="ref-list">9% </td>
                      <td className="ref-list2">2</td>
                    </tr>
                    <tr>
                      <td className="ref-list1">Level 3 </td>
                      <td className="ref-list">10% </td>
                      <td className="ref-list2">3</td>
                    </tr>
                    <tr>
                      <td className="ref-list1">Level 4 </td>
                      <td className="ref-list">11% </td>
                      <td className="ref-list2">4</td>
                    </tr>
                    <tr>
                      <td className="ref-list1">Level 5 </td>
                      <td className="ref-list">12% </td>
                      <td className="ref-list2">+5</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="offset-md-1 col-md-10">
              <div className="dapp_radar_outer">
                <ul>
                  <li>
                    <a target={"_blank"} href="#">
                      <img
                        className="imgDappRadar footer-ico"
                        src="data:image/png;base64,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"
                        alt="icon"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://bscscan.com/address/${config.CONTRACT_ADDRESS}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="bsc footer-ico"
                        src="data:image/png;base64,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"
                        alt="icon"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://shieldcrypto.info/rocky`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="shield footer-ico"
                        src="../logo_white.png"
                        alt="icon"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="offset-md-1 col-md-10">
              <div className="dapp_radar_outer">
                <ul>
                  <li>
                    <a target={"_blank"} href="https://t.me/RockyMiner">
                      <img
                        className="imgDappRadar footer-ico"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/2048px-Telegram_logo.svg.png"
                        alt="icon"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://twitter.com/rockyminer_team`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="imgDappRadar footer-ico"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Twitter-logo.svg/2491px-Twitter-logo.svg.png"
                        alt="icon"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      target={"_blank"}
                      href="https://www.instagram.com/rockyminer.team/"
                    >
                      <img
                        className="imgDappRadar footer-ico"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Instagram_logo_2016.svg/2048px-Instagram_logo_2016.svg.png"
                        alt="icon"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://discord.gg/SPGfyvgKUg`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="imgDappRadar footer-ico"
                        src="https://cdn3.iconfinder.com/data/icons/popular-services-brands-vol-2/512/discord-512.png"
                        alt="icon"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://www.facebook.com/RockyMiner.Team/`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="imgDappRadar footer-ico"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Facebook_f_logo_%282019%29.svg/2048px-Facebook_f_logo_%282019%29.svg.png"
                        alt="icon"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default MainPage;
